export const prepareGoalsForSuggestion = (activeGoals: any) => {
    let prepareGoalsAccToSuggestion: any = [];

    if(activeGoals.length === 0) {
        const goalsObject = {
            value: 'Not Found',
            id: -1,
            label: 'Not Found',
            isRemovable: false
        }
        prepareGoalsAccToSuggestion.push(goalsObject);
        return prepareGoalsAccToSuggestion;
    }
    // debugger;
    
    activeGoals.forEach((goal: any) => {
        const goalsObject = {
            value: goal && goal.name,
            id: goal && goal._id,
            label: goal && goal.name,
            isRemovable: true
        }
        prepareGoalsAccToSuggestion.push(goalsObject);
    });
    return prepareGoalsAccToSuggestion;
}